import Coming from "../components/Coming";
export default function Product() {
    return(
            <>
                <input type="hidden" id="comingDate" value="2025/1/15"/>
                <Coming />
            </>
    );
}